import {useSelector} from 'react-redux'
import {RootState} from '../../setup/redux'

export const useAppSelector = <T>(selector: (state: RootState) => T) =>
  useSelector<RootState, T>(selector)
